import { medusaRequester, storeRequester } from "App";
import AnimatedSwitch from "components/AnimatedSwitch";
import Dummy from "components/Dummy";
import P from "components/P";
import initialSearchCondition from "InitialData/InitialSearchCondition.json";
import Container from "layouts/container/Container";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import CardList from "layouts/wrapper/CardList";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import MenuBar from "routes/front/menuBar/MenuBar";
import { clone, isEqual } from "shared/utils/Utils";
import gridIcon from "resources/img/category/grid.png";
import listIcon from "resources/img/category/list.png";
import Center from "layouts/wrapper/Center";
import MobileFilterTopBar from "./filter/MobileFilterTopBar";
import FilterTopBar from "./filter/FilterTopBar";
import { useSelector } from "react-redux";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";

function SearchResult(props) {
  const { isMobile } = useContext(BrowserDetectContext);
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const preventRef = useRef(true);
  const obsRef = useRef(null);
  const [list, setList] = useState();
  const [medusaProducts, setMedusaProducts] = useState();
  const [currentSearchCondition, setCurrentSearchCondition] = useState();
  const [filterCondition, setFilterCondition] = useState();
  const [filter, setFilter] = useState(0);
  const { isCurrentType } = useSelector((state) => ({
    isCurrentType: state.history.isCurrentType,
  }));
  const [currentType, setCurrentType] = useState(isCurrentType);
  const [triggerKey, setTriggerKey] = useState(0);
  const { categoryId } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const observer = new IntersectionObserver(obsHandler, { threshold: 0.5 });
    if (obsRef.current) {
      observer.observe(obsRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const search = (searchCondition) => {
    storeRequester.getProducts(
      { q: searchCondition.keyword, expand: "variants.prices" },
      ({ products }) => setList(products)
    );
  };

  useEffect(() => {
    if (location && location.state) {
      storeRequester.getProducts(
        {
          type: "main",
          limit: 100,
          offset: 0,
          q: location.state.search,
          // category_id : 카테고리 아이디 검색
        },

        ({ products }) => {
          setList(products);

          setTriggerKey((prevKey) => prevKey + 1);
        }
      );
    }
  }, [location]);

  const obsHandler = (entries) => {
    const target = entries[0];
    if (target.isIntersecting && preventRef.current) {
      preventRef.current = false;
      setPage((prev) => prev + 1);
    }
  };

  const onFilterClose = (filter) => {
    let searchCondition = clone(initialSearchCondition);
    searchCondition.categories = filter.categories;
    searchCondition.brands = filter.brands;
    search(searchCondition);
  };

  useEffect(() => {
    if (!isEqual(filterCondition, currentSearchCondition)) {
      // setCurrentSearchCondition(filterCondition);
    }
  }, [filterCondition]);

  useEffect(() => {
    if (currentSearchCondition) {
      search(currentSearchCondition);
    }
  }, [currentSearchCondition]);

  useEffect(() => {
    if (categoryId === "find") {
    } else if (categoryId === "event") {
      storeRequester.getProducts(
        {
          type: "main",
          mix: true,
          limit: 100,
          offset: 0,
          only: "promotion"
          // q : 검색용
          // category_id : 카테고리 아이디 검색
          // order : 정렬(인기,신규,낮은,높은) 순서대로 0,1,2,3
        },
        ({ products }) => {
          setTriggerKey((prevKey) => prevKey + 1);
          setList(products);
        })
    } else if (categoryId) {
      filterClick(0);
    }
  }, [categoryId]);

  const filterArray = ["인기순", "신상품순", "높은가격순", "낮은가격순"];
  const filterClick = (index) => {
    setFilter(index);

    if (categoryId === "find") {
      let data2 = {
        type: "main",
        limit: 100,
        offset: 0,
        q: location.state.search,
        category_id: index,
        mix: true,
      };
      storeRequester.getProducts(data2, ({ products }) => {
        setTriggerKey((prevKey) => prevKey + 1);
        setList(products);
      });
    } else if (categoryId === "event") {
      let data3 = {
        type: "main",
        limit: 100,
        offset: 0,
        only: "promotion",
        // q: location.state.search,
        category_id: index,
        mix: true,
      };
      storeRequester.getProducts(data3, ({ products }) => {
        setTriggerKey((prevKey) => prevKey + 1);
        setList(products);
      });
    }
    else {
      // if (categoryId === "all") {
      let data = {
        type: "main",
        limit: 100,
        offset: 0,
        mix: true,
        // q : 검색용
        // category_id : 카테고리 아이디 검색

        order: index, //인기순 신상품순
      };
      if (categoryId !== "all") {
        data.category_id = categoryId;
      }
      storeRequester.getProducts(data, ({ products }) => {
        setTriggerKey((prevKey) => prevKey + 1);
        setList(products);
      });
    }
  };

  return (
    <Container>
      <div>
        {isMobile && <MenuBar filterClick={filterClick} />}
        <Container minWidth={!isMobile && 1300} maxWidth={1300}>
          <VerticalFlex gap={10}>
            <FlexChild>
              <div style={{ position: "relative" }}>
                {isMobile ? (
                  <MobileFilterTopBar
                    filterArray={filterArray}
                    medusaProducts={medusaProducts}
                    list={list}
                    categoryId={categoryId}
                    setCurrentType={setCurrentType}
                    filter={filter}
                    filterClick={filterClick}
                  />
                ) : (
                  <FilterTopBar
                    filterArray={filterArray}
                    medusaProducts={medusaProducts}
                    list={list}
                    categoryId={categoryId}
                    setCurrentType={setCurrentType}
                    filter={filter}
                    filterClick={filterClick}
                  />
                )}
              </div>
            </FlexChild>
            <FlexChild>
              <Dummy height={isMobile ? "5px" : "120px"} />
            </FlexChild>
            <FlexChild>
              <Dummy height={isMobile ? "60px" : "20px"} />
              <AnimatedSwitch animationClass={"fade"} triggerKey={triggerKey}>
                <CardList
                  data={list}
                  template={"addWish"}
                  currentType={currentType}
                  setCurrentType={setCurrentType}
                />
              </AnimatedSwitch>
            </FlexChild>
            <FlexChild>
              <div ref={obsRef}></div>
            </FlexChild>
          </VerticalFlex>
        </Container>
      </div>
    </Container>
  );
}

export default SearchResult;
